import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { Box, makeStyles } from '@material-ui/core';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { translationsSelector } from '../../../selectors/translations';
import { onClickWrapper } from '../../../utils/ui';
import { useAppWidthClass } from '../../../utils/hooks';

import { CustomIcon } from '../../common';
import { PaymentFormText } from '../index.troy';
import { enqueueSnackbar } from '../../../actions/snackbar';

const useStyles = makeStyles(theme => ({
  root: {
    paddingBottom: 16,
    cursor: 'default'
  },
  table: {
    padding: '8px 0'
  },
  tableCompact: {
    padding: '24px 0'
  },
  label: {
    ...theme.typography.body1Bold,
    display: 'inline-block',
    minWidth: 88,
    color: theme.palette.secondary.main
  },
  labelCompact: {
    ...theme.typography.body2Bold
  },
  valueContainer: {
    position: 'relative',
    display: 'inline-block',
    minWidth: 230
  },
  valueContainerCompact: {
    minWidth: 198
  },
  value: {
    ...theme.typography.body1,
    color: theme.palette.secondary.main,
    cursor: 'pointer',
    transition: theme.transitions.custom.fast,

    '&:hover': {
      color: theme.palette.secondary.dark,

      '& + *': {
        display: 'block'
      }
    }
  },
  valueCompact: {
    ...theme.typography.body2
  },
  copy: {
    display: 'none',
    position: 'absolute',
    top: '50%',
    right: -16,
    transform: 'translateY(-50%)'
  }
}));

const TABLE = (username, translations) => [
  {
    id: 'iban',
    label: 'IBAN',
    value: translations['SEPA_PAYMENT_PANEL_IBAN']
  },
  {
    id: 'bic',
    label: 'BIC',
    value: translations['SEPA_PAYMENT_PANEL_BIC']
  },
  {
    id: 'purpose',
    label: translations['SEPA_PAYMENT_PANEL_PURPOSE_TEXT'],
    value: `Aktenzeichen ${username}`
  }
];

const SepaContent = ({ username }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isMobileWidth } = useAppWidthClass();

  const translations = useSelector(translationsSelector);

  const onCopy = () =>
    dispatch(
      enqueueSnackbar({
        message: 'Copied!',
        options: {
          variant: 'success'
        }
      })
    );

  return (
    <Box className={classes.root} id="offline-sepa">
      <PaymentFormText>SEPA_PAYMENT_PANEL_PAYMENT_TEXT</PaymentFormText>
      <Box
        className={classNames(
          classes.table,
          isMobileWidth && classes.tableCompact
        )}
      >
        {TABLE(username, translations).map(({ id, label, value }) => (
          <Box key={label}>
            <span
              className={classNames(
                classes.label,
                isMobileWidth && classes.labelCompact
              )}
            >
              {label}
            </span>
            <span
              className={classNames(
                classes.valueContainer,
                isMobileWidth && classes.valueContainerCompact
              )}
            >
              <CopyToClipboard
                onCopy={onClickWrapper(
                  'page.payments.offline_sepa.copy-to-clipboard',
                  onCopy
                )}
                text={value}
              >
                <span
                  id={`page-payments-offline-sepa-${id}`}
                  className={classNames(
                    classes.value,
                    isMobileWidth && classes.valueCompact
                  )}
                  role="button"
                >
                  {value}
                </span>
              </CopyToClipboard>
              <CustomIcon
                className={classes.copy}
                icon="copyPaste"
                size="xs"
                variant="textPrimary"
              />
            </span>
          </Box>
        ))}
      </Box>
      <PaymentFormText>SEPA_PAYMENT_PANEL_NOTE</PaymentFormText>
    </Box>
  );
};

export default SepaContent;
